export default "/images/vendor/flag-icons/flags/1x1/ca.svg?27f31b05aefedba14066678956638a05";